module.exports = require("./../../_gen/starling/events/EventDispatcher");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/events/EventDispatcher.js
// module id = 181
// module chunks = 0